import React from 'react';
import { MARK } from '../../../constants';
import { criticidadeDoServico } from '../../../utils/calculations/prazos';
import { entradaAEmitir } from '../../../utils/calculations/entrada';

/**
 * O QUE ESTÁ ERRADO NESTE SERVIÇO, na mesma língua em toda tela.
 *
 * O Dashboard já dizia isto bem: "Entrada a emitir, TE há 12d", "Parcela
 * vencida há 4d", "Pode faturar e não foi faturado". Frases curtas, com o
 * prazo dentro, que se lê de relance numa lista de trinta.
 *
 * O Financeiro do serviço contava os mesmos fatos com outras palavras e outro
 * recorte — a entrada aparecia como "R$ 1.805 em fatura 2026-0034", o
 * faturamento pendente não aparecia — e o mesmo serviço lido nas duas telas
 * parecia dois serviços diferentes. Quem cobra abre as duas.
 *
 * POR QUE UM MÓDULO, E NÃO COPIAR AS QUATRO LINHAS
 *
 * Porque a divergência não nasceu de ninguém escrever errado: nasceu de os
 * dois lugares montarem os ARGUMENTOS por conta própria. `criticidadeDoServico`
 * recebe parcelas, valor, entrada paga, entrada emitida e `entradaAEmitir` —
 * cinco entradas, e basta uma sair diferente para a mesma conta dar outro
 * resultado. Montar os argumentos aqui é o que garante a mesma resposta; o
 * componente de baixo só desenha.
 */

/**
 * Os motivos de um serviço, com os argumentos montados de um jeito só.
 *
 * `laboratory` entra porque `entradaAEmitir` precisa da taxa do contrato —
 * é a mesma razão de `valor` chegar pronto: `criticidadeDoServico` não quer
 * conhecer nem o laboratório nem os sete modelos de cobrança.
 */
export const motivosDoServico = (service, {
  parcelas = [], valor = 0, entradaPaga = 0, entradaEmitida = false, laboratory = null,
} = {}) => criticidadeDoServico(service, {
  parcelas,
  valor,
  entradaPaga,
  entradaEmitida,
  entradaAEmitir: entradaAEmitir(service, laboratory, entradaEmitida),
});

/**
 * Desenha os motivos, e nada quando não há.
 *
 * `truncar` é o que muda entre as telas: na linha do Pipeline o texto divide
 * espaço com sete colunas de data e precisa caber em 160px; no Financeiro do
 * serviço há a largura do modal inteira, e cortar ali esconderia justamente o
 * que a tela foi aberta para ler.
 */
const MotivosDoServico = ({ motivos = [], truncar = false, dataCurta = null, className = '' }) => {
  if (!motivos || motivos.length === 0) return null;

  return (
    <div className={className}>
      {motivos.map(m => (
        <p
          key={m.tipo}
          className={`text-xs text-slate-800 font-medium ${truncar ? 'truncate max-w-[160px]' : ''}`}
          title={m.desde && dataCurta ? `Desde ${dataCurta(m.desde)}` : undefined}
        >
          {MARK.WARN} {m.texto}
        </p>
      ))}
    </div>
  );
};

export default MotivosDoServico;
